export const COMPANY_DESCRIPTION = "Mapka is platform for map layers";
export const COMPANY_NAME = "Mapka";
export const EMAIL_DOMAIN = "mapka.dev";
export const NO_REPLY_EMAIL_ADDRESS = "no-reply@mapka.dev";
export const PRODUCT = "Mapka";
export const PROJECT_CODE = "mapka";
export const PROJECT_URL = "https://mapka.dev";
export const SALES_EMAIL_ADDRESS = "sales@mapka.dev";
export const DISCORD_URL = "https://discord.gg/VBNT5ZCgeJ";
export const GITHUB_URL = "https://github.com/mapka-dev";
export const FACEBOOK_URL = "https://facebook.com/mapka.dev";
export const YOUTUBE_URL = "https://youtube.com/@mapka-dev";
export const TWITTER_URL = "https://x.com/Mapka65438";
export const LINKEDIN_URL = "https://linkedin.com/company/mapka";
//# sourceMappingURL=company.js.map